import { BaseService } from 'core/services';
import ScheduleRouteService from './ScheduleRouteService';

class ScheduleService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ScheduleRouteService());
    }

    async regenerate(resource) {  
        const url = this.routeService.regenerate(resource);
        return this.apiClient.post(url, resource);
    }
    
    async generate(resource) {  
        const url = this.routeService.generate(resource);
        return this.apiClient.post(url, resource);
    }

    async getUserDaily(options){
        const url = this.routeService.getUserDaily(options);
        return this.apiClient.get(url);
    }

    async getPastOrders(options){
        const url = this.routeService.getPastOrders(options);
        return this.apiClient.get(url);
    }

    async getPreviousTasks(options){
        const url = this.routeService.getPreviousTasks(options);
        return this.apiClient.get(url);
    }

    async getFutureTasks(options){
        const url = this.routeService.getFutureTasks(options);
        return this.apiClient.get(url);
    }

    async getCurrentTasksByRoles(options){
        const url = this.routeService.getCurrentTasksByRoles(options);
        return this.apiClient.get(url);
    }

    async getTypes(){
        const url = this.routeService.getTypes();
        const response = await this.apiClient.get(url);
        return response.data || null;
    }

    async updateDates(resource){
        const url = this.routeService.updateDates(resource);
        const response = await this.apiClient.put(url, resource);
        return response.data || null;
    }

    async updateDate(resource){
        const url = this.routeService.updateDate(resource);
        const response = await this.apiClient.put(url, resource);
        return response.data || null;
    }

    async updateLinkedTask(resource){
        const url = this.routeService.updateLinkedTask(resource);
        const response = await this.apiClient.put(url, resource);
        return response.data || null;
    }

    async copyNote(resource) {
        const url = this.routeService.copyNote(resource);
        const response = await this.apiClient.put(url, resource);
        return response.data || null;
    }

    async sendOrder(resource) {
		const url = await this.routeService.sendOrder(resource);
		return this.apiClient.put(url, resource);
	} 

    async batchUpdate(resource) {	
		const url = this.routeService.batchUpdate(resource);
        const response = await this.apiClient.put(url, resource);
        return response.data || null;
	}
    
    getDownloadUrl(filter){
        return this.apiClient.appOptions.apiUrl + this.routeService.download(filter);
    }

    async sendOrderNewFlow(resource) {
		const url = await this.routeService.sendOrderNewFlow(resource);
		return this.apiClient.put(url, resource);
	} 

    async sendOrderOrderSummaryNewFlow(resource) {
		const url = await this.routeService.sendOrderOrderSummaryNewFlow(resource);
		return this.apiClient.put(url, resource);
	} 
}

export default ScheduleService;
